const initialState = {
  cond: false,
  loading: false,
  latlng: null,
  houses: [],
  domkom: null,
  domkomCadastr: null,
  points: [],
  business: [],
  selectedBusiness: null,
  xatlovAddress: null
}

const xatlov = (state = initialState, action) => {
  switch (action.type) {
    case "XATLOV_LOADING":
      return { ...state, loading: action.val }
    case "XATLOV_ACTIVATE":
      return { ...state, cond: action.val }
    case "XATLOV_SET_POSITION":
      return { ...state, latlng: action.val }
    case "XATLOV_INACTIVATE":
      return { ...state, cond: action.val }
    case "INSERT_XATLOV_TURAR":
      return { ...state, houses: action.val }
    case "INSERT_DOMKOM":
      return { ...state, domkom: action.val }
    case "INSERT_DOMKOM_CADASTR":
      return { ...state, domkomCadastr: action.val }
    case "INSERT_XATLOV_WHAT_IS_HERE":
      return { ...state, points: action.val }
    case "INSERT_XATLOV_NOTURAR":
      return { ...state, business: action.val }
    case "SELECTED_XATLOV_BUSINESS":
      return { ...state, selectedBusiness: action.val }
    case "XATLOV_ADDRESS":
      return { ...state, xatlovAddress: action.val }
    default:
      return state
  }
}

export default xatlov
